angular.module('SpidApp')

.factory('Chunker', function () {
  return {
    inConstantSizeChunks: function (array, chunkSize) {
      if (!array || chunkSize === undefined || chunkSize === null) {
        throw 'Chunker::inConstantSizeChunks() - Missing parameters'
      }
      
      if(chunkSize < 1) {
        throw 'Chunker::inConstantSizeChunks() - Malformed parameters'
      }

      return array.map(function(e,i){ 
        return i % chunkSize === 0 ? array.slice(i, i + chunkSize) : null;
      }).filter(function(e) {
        return e
      })
    }
  }
})